import * as React from "react";
import { DateTime } from "luxon";
import { mjd2unix } from "./helpers/timeParser";
function getUTCString(date) {
    return DateTime.fromMillis(mjd2unix(date)).toUTC().toISO();
}
export default class TooltipHandler extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        const { mouse, isNumber } = this.props;
        if (mouse) {
            const xp = isNumber
                ? this.props.xScale.invert(mouse[0])
                : getUTCString(this.props.xScale.invert(mouse[0]));
            const xpMJD = !isNumber ? this.props.xScale.invert(mouse[0]) : null;
            const yp = this.props.yScale.invert(mouse[1]);
            const y2Coords = this.props.y2Scale
                ? this.props.y2Scale.invert(mouse[1])
                : undefined;
            return (React.createElement("div", { className: "fixed-tooltip-right", style: {
                    right: `${this.props.marginRight}px`,
                } },
                xpMJD && (React.createElement("span", null,
                    React.createElement("b", null, "XMJD:"),
                    ` ${xpMJD}`)),
                React.createElement("span", null,
                    React.createElement("b", null, "X:"),
                    ` ${xp}`),
                React.createElement("span", null,
                    React.createElement("b", null, "Y:"),
                    " ",
                    ` ${yp}`),
                this.props.isAnyY2Visible && y2Coords && (React.createElement("span", null,
                    React.createElement("b", null, "Y2:"),
                    " ",
                    ` ${y2Coords}`))));
        }
        else {
            return "";
        }
    }
}
//# sourceMappingURL=TooltipHandler.js.map